import type { Locale } from '@staiter/shared';
import { createContext } from 'react';

export const LocaleCtx = createContext<Locale>('ru');
